function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M3.873 9.017a1.89 1.89 0 01.483-2.67 1.997 1.997 0 012.685.402l.05.07L8.182 8.34a.853.853 0 01-.218 1.206l-.824.563c-.372-.342-.727-.39-1.216-.323-.803.111-1.578-.11-2.05-.77zM6.043 10.834a1.43 1.43 0 011.659.154c.235.132.442.314.603.536l2.482 2.668H9.745l.744 1.208 5.381-1.408c.123.45-.01.812-.628 1.144l-3.795 1.728a.796.796 0 01-.14.05l-.825.216a.871.871 0 01-.273.027.813.813 0 01-.638-.244l-.14-.145-2.48-2.576H5.402a3.42 3.42 0 01-.03-.451v-1.57a1.361 1.361 0 01.67-1.337z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.304 17.55l5.684-2.57H29v3.633c0 2.451-2.034 4.439-4.544 4.439H7.545C5.035 23.052 3 21.064 3 18.613V14.98h3.81l1.331 1.396.809.847c.217.245.815.695 1.29.61.04-.005.08-.011.12-.022l.804-.21a.848.848 0 00.14-.05zM7.552 26h1.414l.387-1.988H7.659L7.552 26zM22.906 26h1.414l-.107-1.988H22.52L22.906 26z",
  fill: "currentColor"
})));